import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from '@piplapps/pipl-ui';
import styles from './ResendInviteModal.module.less';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import LoadingButton from '../../../../Components/LoadingButton';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const removeInvite = (props) => {
  const { userData } = props;
  const handleRemove = useCallback(() => {
    props.onRemoveInvite(userData.status.invite_id);
  }, [userData]);

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{props.title}</div>
      <span
        tabIndex={0}
        role="button"
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>
      <div className={styles.text}>
        {gettext('Are you sure you want to permanently remove the user ')}
        <strong>{gettext(` ${userData.first_name} ${userData.last_name} (${userData.email})`)}</strong>?
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <AnalyticsHandler eventName={AnalyticsEventNames.REMOVE_INVITE}>
            <LoadingButton
              id="submit-button"
              buttonClass="primary-red"
              type="submit"
              onClick={() => handleRemove()}
              text={gettext('Remove user')}
              loadingText={gettext('Removing')}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
            id="cancel-button"
          />
        </div>
      </div>
    </div>
  );
};

removeInvite.propTypes = {
  userData: PropTypes.object,
  title: PropTypes.string,
  onRemoveInvite: PropTypes.func,
  clickedCloseModalButton: PropTypes.func,
};

const mapDispatchToProps = {
  onRemoveInvite: UsersActions.removeInvite,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
};

export default connect(null, mapDispatchToProps)(removeInvite);
